"use client";

import { getFeatureFlag, type FeatureFlagKey, type FeatureFlagMeta } from "./flags";

/**
 * Read a feature flag. Returns whether it is enabled plus its metadata so a
 * caller can render a "coming soon" affordance when it is off.
 *
 * Backed by a static config today; kept as a hook so the source can become
 * runtime/remote later without touching call sites.
 */
export function useFeatureFlag(key: FeatureFlagKey): FeatureFlagMeta {
  return getFeatureFlag(key);
}
